import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LandingNavigationAnalytic } from '../models/analytic.model';
import { UsageTrackingServiceInterface } from '../models/usage-tracking-service.interface';
import { APPLICATION, GENERAL_ACTION_TYPES } from '../usage-tracking.config';
import { TrackingService } from './tracking.service';

@Injectable({ providedIn: 'root' })
export class LandingNavigationTrackingService implements UsageTrackingServiceInterface {
  private readonly trackingService = inject(TrackingService);
  private readonly router = inject(Router);

  public addUsageTracking(): void {
    const action = GENERAL_ACTION_TYPES.navigation;
    const application = APPLICATION;
    const landingNavigationAnalytic: LandingNavigationAnalytic = {
      url: this.router.url,
      application,
      action,
    };

    this.trackingService.addUsageTracking(landingNavigationAnalytic);
  }
}
